<template>
  <div>    
    <header>      
      <nav class="navbar navbar-expand-md navbar-light fixed-top bg-light">
        <div class="container-fluid">
            <button v-show="!homePage" class="btn" type="button" @click="goBack">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                fill="currentColor"
                class="bi bi-arrow-left"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
                />
              </svg>
            </button>

            <a
              v-show="homePage"
              class="btn"
              data-bs-toggle="offcanvas"
              data-bs-target="#userPanel"
              aria-controls="userPanel"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                fill="currentColor"
                class="bi bi-person-circle"
                viewBox="0 0 16 16"
              >
                <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                <path
                  fill-rule="evenodd"
                  d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
                />
              </svg>
            </a>

          <a class="navbar-brand mx-auto" href="#"
            ><img alt="IzOnay" src="../assets/logo.png"
          /></a>              
                <a
                  class="btn"
                  @click="$router.push({ name: 'Dashboard' })"
                >
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-house" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M2 13.5V7h1v6.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V7h1v6.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5zm11-11V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"/>
                  <path fill-rule="evenodd" d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"/>
                </svg>
                </a>
        </div>
      </nav>      
      <user></user>
    </header>
    <main id="main" role="main" class="d-flex align-items-center">
      <div class="container-fluid">
        
      <router-view />
      </div>
    </main>
  </div>
</template>
<script>
import User from "../components/User.vue";

export default {
  components:{
    User
  },
  created() {
    if (!this.$root.$data.login) {
      this.$router.push("/");
    }
  },
  computed: {
    homePage() {
      if(this.$route.path == "/index" || this.$route.path == "/index/") {
        return true
      } else {
        return false
      }
    }
  }
};
</script>

<style scoped>
#main {
  padding-top: 60px;
  padding-bottom: 20px;
}
</style>
